<div class="row shadow title-list bg-white rounded">
    <div class="pt-2" style="width: 54%; margin-left: 2.5rem; margin-top: 0.4rem;">
        <h1 class="lblTitle-02">
            {{ 'working-day.lblTitle' | translate }}
        </h1>
    </div>

    <form [formGroup]="fmFilters" (ngSubmit)="onLoadGrid(false)" class="d-flex align-items-top"
        style="width: 40%; gap: 1rem;" autocomplete="off">

        <mat-form-field appearance="outline" class="search-field">
            <mat-label>{{ 'working-day.lblRegisterDate' | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="txtFechaAlta">
                <input matStartDate placeholder="Fecha inicio" formControlName="txtDateInit">
                <input matEndDate placeholder="Fecha fin" formControlName="txtDateEnd">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="txtFechaAlta"></mat-datepicker-toggle>
            <mat-date-range-picker #txtFechaAlta></mat-date-range-picker>
        </mat-form-field>

        <div class="btn-group" style="margin-top: 0.5rem;">
            <button type="button" class="btn btn-primary mr-3 w-120-px" (click)="onLoadGrid(true)">
                <i class="fas fa-search text-white mr-2"></i>
                {{ 'common.btnSearch' | translate }}
            </button>

            <button type="button" class="btn btn-secondary flex-justif-alig-center w-100-px" (click)="removeFilter()">
                <i class="fas fa-times mr-2"></i>
                {{ 'common.btnClear' | translate }}
            </button>
        </div>
    </form>
</div>

<div class="row">
    <div class="" style="width: 60%; margin-left: 3.5%;">
        <div class="mt-3 text-black">
            <span>{{ userDetail.fullname }}</span>
        </div>
    </div>
    <div class="" style="width: 20%;">
        <div class="notification-info text-center">
            <div class="text-notification">
                <span>{{ 'working-day.lblTotalHours' | translate }}</span> {{ userDetail.totalHours }}
                <span>{{ 'working-day.lblHours' | translate }}</span>
            </div>
        </div>
    </div>
    <div class="text-end" style="width: 15%;">
        <button type="button" class="btn btn-download-report ml-3 mb-4" (click)="onDownloadDataGrid()">
            {{ 'working-day.btnDownload' | translate }}
        </button>
    </div>
</div>

<div class="container-fluid">
    <div class="form-details">
        <div class="row">
            <div class="col-md-3">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'working-day.lblPosition' | translate}}
                    </mat-label>
                    <input matInput maxlength="48" value="{{ userDetail.position }}"
                        placeholder="{{ 'working-day.lblPosition' | translate}}" readonly="true">
                </mat-form-field>
            </div>
            <div class="col-md-3">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'working-day.lblGroupName' | translate}}
                    </mat-label>
                    <input matInput maxlength="48" value="{{ userDetail.groupName}}"
                        placeholder="{{ 'working-day.lblGroupName' | translate}}" readonly="true">
                </mat-form-field>
            </div>
            <div class="col-md-3">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'working-day.lblEmail' | translate}}
                    </mat-label>
                    <input matInput maxlength="48" value="{{ userDetail.email}}"
                        placeholder="{{ 'working-day.lblEmail' | translate}}" readonly="true">
                </mat-form-field>
            </div>
            <div class="col-md-3">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'working-day.lblPlatformId' | translate}}
                    </mat-label>
                    <input matInput maxlength="48" value="{{ userDetail.idPlatform}}"
                        placeholder="{{ 'working-day.lblPlatformId' | translate}}" readonly="true">
                </mat-form-field>
            </div>
            <div class="col-md-3">
                <mat-form-field appearance="outline" class="d-block form-control">
                    <mat-label>
                        {{ 'working-day.lblRegisterDate' | translate}}
                    </mat-label>
                    <input matInput maxlength="48" value="{{ userDetail.dateInit | date: 'dd/MM/yyyy' }}"
                        placeholder="{{ 'working-day.lblRegisterDate' | translate}}" readonly="true">
                </mat-form-field>
            </div>

            <div class="col-lg-3">
                <button type="button" class="btn btn-download-filter-cae ml-3 mb-4 color-primary"
                    (click)="displayImage(viewImage)">
                    {{ 'working-day.btnShowPhoto' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>


<div class="row mt-3">
    <div class="content-wrap px-3">
        <table class="table table-custom table-hover table-sm table-grid-responsive">
            <caption></caption>
            <thead class="th-custom">
                <tr>
                    <th class="th-status"></th>
                    <th class="th-grid-responsive">{{ 'working-day.gridColumns.position' | translate }}</th>
                    <th class="th-grid-responsive">{{ 'working-day.gridColumns.name' | translate }}</th>
                    <th class="th-grid-responsive">{{ 'working-day.gridColumns.registerDate' | translate }}</th>
                    <th class="th-grid-responsive">{{ 'working-day.gridColumns.name' | translate }}</th>
                    <th class="th-grid-responsive">{{ 'working-day.gridColumns.registerDate' | translate }}</th>
                    <th class="th-grid-responsive">{{ 'working-day.gridColumns.totalHours' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="dataGrid && dataGrid.length > 0">
                    <ng-container *ngFor="let data of dataGrid">
                        <tr class="tr-custom">
                            <td class="status__completed">
                            </td>
                            <td class="td-grid-responsive">
                                {{ data.position }}
                            </td>
                            <td class="td-grid-responsive">
                                {{ data.typeNameStart }}
                            </td>
                            <td class="td-grid-responsive">
                                {{ data.dateStart | date: 'dd/MM/yyyy H:mm:ss' }}
                            </td>
                            <td class="td-grid-responsive">
                                {{ data.typeNameEnd }}
                            </td>
                            <td class="td-grid-responsive">
                                {{ data.dateEnd | date: 'dd/MM/yyyy H:mm:ss' }}
                            </td>
                            <td class="td-grid-responsive">
                                {{ data.workHours }}
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
                <tr *ngIf="this.emptyDataList && this.IsPostBack" class="grid-empty text-center bg-light">
                    <td colspan="12" class="mt-3 h-360-px justify-all-center">
                        <img class="img-folder-empty" src="assets/images/icon/Folder.svg" alt="empty folder">
                        <br>
                        <span class="text-info-gray fw-w-bold">
                            {{ 'working-day.lblNoData' | translate }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="row mr-4 mt-1">
            <div class="col-md-12 mb-5 d-flex justify-content-end">
                <app-pagination-table [totalPages]="totalPages" [currentPage]="currentPage"
                    (changePage)="changePage($event)"></app-pagination-table>
            </div>
        </div>
    </div>
</div>

<ng-template #viewImage>
    <div class="modal-header modal-header-custom">
        <div class="flex justify-content-space-between">
            <!-- <span class="fw-bold title-modal-detail fz-14-px">
                {{ 'working-day.lblDetail' | translate }}
            </span> -->

            <div class="mt-3 text-black">
                <span>{{ userDetail.fullname }}</span>
            </div>
        </div>
        <hr class="line-h-blue-purple-dialogs">
    </div>
    <div class="hr-detail"></div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12 text-center">
                <img alt="Selfie" class="img-user-cae" [src]="imagePath">
            </div>
        </div>
    </div>
    <div class="modal-footer mt-1">
        <button class="btn btn-secondary " data-dismiss="modal" (click)="onClose(0)">
            {{ 'common.btnCancel' | translate }}
        </button>
    </div>
</ng-template>